import { Navigate } from 'react-router';
import { useAuth } from '@/providers/AuthProvider';
import { UserRole } from '@/types/enums';

export default function RootRedirect() {
  const { user, isAuthenticated, authLoading } = useAuth();

  if (authLoading) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated && user) {
    const dashboardPath =
      user.role === UserRole.ADMIN ? '/admin/dashboard' : '/crew/dashboard';

    return <Navigate to={dashboardPath} replace />;
  }

  return <Navigate to="/login" replace />;
}
